import { List } from 'immutable';
import { AccountMigration } from './models/account-migration.model';
import { IDispatchId, IRequestError } from '../../utils/helpers/redux.helper';

// action enums
export enum ActionsEnum {
  FETCH_ACCOUNT_MIGRATION = 'FETCH_ACCOUNT_MIGRATION',
  FETCH_ACCOUNT_MIGRATION_ERROR = 'FETCH_ACCOUNT_MIGRATION_ERROR',
  UPDATE_ACCOUNT_MIGRATION = 'UPDATE_ACCOUNT_MIGRATION',
  SET_COMPLETED_ONBOARDING_DATA = 'SET_COMPLETED_ONBOARDING_DATA',
  MARK_ONBOARDING_AS_COMPLETED = 'MARK_ONBOARDING_AS_COMPLETED',
  COMPLETE_MIGRATION = 'COMPLETE_MIGRATION',
  COMPLETE_MIGRATION_SUCCESS = 'COMPLETE_MIGRATION_SUCCESS',
  COMPLETE_MIGRATION_ERROR = 'COMPLETE_MIGRATION_ERROR',
}

// action payloads
export interface IAccountMigration {
  accountMigration: AccountMigration;
}

export interface ISetCompletedOnboardingDataPayload {
  accountUserIds: List<string>;
}

export interface ICompleteMigrationPayload extends IDispatchId {}

export interface ICompleteMigrationErrorPayload extends IRequestError {}

// action definitions
export interface FetchAccountMigration {
  type: ActionsEnum.FETCH_ACCOUNT_MIGRATION;
}

export interface FetchAccountMigrationError {
  type: ActionsEnum.FETCH_ACCOUNT_MIGRATION_ERROR;
}

export interface UpdateAccountMigration {
  type: ActionsEnum.UPDATE_ACCOUNT_MIGRATION;
  payload: IAccountMigration;
}

export interface MarkOnboardingAsCompleted {
  type: ActionsEnum.MARK_ONBOARDING_AS_COMPLETED;
}

export interface SetCompletedOnboardingData {
  type: ActionsEnum.SET_COMPLETED_ONBOARDING_DATA;
  payload: ISetCompletedOnboardingDataPayload;
}

export interface CompleteMigration {
  type: ActionsEnum.COMPLETE_MIGRATION;
  payload: ICompleteMigrationPayload;
}

export interface CompleteMigrationSuccess {
  type: ActionsEnum.COMPLETE_MIGRATION_SUCCESS;
  payload: ICompleteMigrationPayload;
}

export interface CompleteMigrationError {
  type: ActionsEnum.COMPLETE_MIGRATION_ERROR;
  payload: ICompleteMigrationErrorPayload;
}

// action creators
export const fetchAccountMigration = (): FetchAccountMigration => ({
  type: ActionsEnum.FETCH_ACCOUNT_MIGRATION,
});

export const fetchAccountMigrationError = (): FetchAccountMigrationError => ({
  type: ActionsEnum.FETCH_ACCOUNT_MIGRATION_ERROR,
});

export const updateAccountMigration = (
  accountMigration: AccountMigration
): UpdateAccountMigration => ({
  type: ActionsEnum.UPDATE_ACCOUNT_MIGRATION,
  payload: {
    accountMigration,
  },
});

export const setCompletedOnboardingData = (
  accountUserIds: List<string>
): SetCompletedOnboardingData => ({
  type: ActionsEnum.SET_COMPLETED_ONBOARDING_DATA,
  payload: {
    accountUserIds,
  },
});

export const markOnboardingAsCompleted = (): MarkOnboardingAsCompleted => ({
  type: ActionsEnum.MARK_ONBOARDING_AS_COMPLETED,
});

export const completeMigration = (dispatchId: string): CompleteMigration => ({
  type: ActionsEnum.COMPLETE_MIGRATION,
  payload: {
    dispatchId,
  },
});

export const completeMigrationSuccess = (
  dispatchId: string
): CompleteMigrationSuccess => ({
  type: ActionsEnum.COMPLETE_MIGRATION_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const completeMigrationError = (
  dispatchId: string,
  error: Error
): CompleteMigrationError => ({
  type: ActionsEnum.COMPLETE_MIGRATION_ERROR,
  payload: {
    dispatchId,
    error,
  },
});
